<template>
  <pageContent class="aviso">
    <div class="aviso-main">
      <div class="row-text">
        <h1 class="font-blod fade-in">Aviso Legal</h1>
      </div>
      <el-collapse class="collapse" accordion v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i> OBJETO Y ACEPTACIÓN
          </template>
          <p>
            El presente aviso legal regula el uso del sitio web (en adelante, LA
            WEB), del que es titular
            <b class="font-bold">MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L. </b>(en
            adelante, EL PROPIETARIO DE LA WEB). La navegación por el sitio web
            de EL PROPIETARIO DE LA WEB atribuye la condición de usuario del
            mismo e implica la aceptación plena y sin reservas de todas y cada
            una de las disposiciones incluidas en este Aviso Legal, que pueden
            sufrir modificaciones. El usuario se obliga a hacer un uso correcto
            del sitio web de conformidad con las leyes, la buena fe, el orden
            público, los usos del tráfico y el presente Aviso Legal. El usuario
            responderá frente a EL PROPIETARIO DE LA WEB o frente a terceros, de
            cualesquiera daños y perjuicios que pudieran causarse como
            consecu-cia del incumplimiento de dicha obligación.
          </p>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i> IDENTIFICACIÓN Y
            COMUNICACIONES
          </template>
          <p>
            EL PROPIETARIO DE LA WEB, en cumplimiento de la Ley 34/2002, de 11
            de julio, de Servicios de la Sociedad de la Información y de
            Comercio Electrónico, le informa de que:
          </p>
          <ul>
            <li>
              El responsable es
              <b class="font-blod"> MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L.</b>
            </li>
            <li>
              Su CIF es:
              <b class="font-blod"> B01705003</b>
            </li>
            <li>
              Su domicilio está en:
              <b class="font-blod">
                CALLE GÜNTER, 1, 28906 GETAFE, MADRID</b>
            </li>
            <li>
              Inscrita en el registro mercantil en el tomo 40665 folio 70 hoja
              M-721662.
            </li>
          </ul>
          <p>
            Para comunicarse con nosotros, ponemos a su disposición diferentes
            medios de contacto que detallamos a continuación:
          </p>
          <ul>
            <li>
              Email:
              <el-link  href="mailto:info@maragonconstruccion.es" type="primary">info@maragonconstruccion.es</el-link>
            </li>
            <li>
              Telf.:
              <el-link type="primary" href="tel:603440332"
                >603 440 332</el-link
              >
            </li>
          </ul>
          <p>
            Todas las notificaciones y comunicaciones entre los usuarios y EL
            PROPIETARIO DE LA WEB se considerarán eficaces, a todos los efectos,
            cuando se realicen a través de correo postal o cualquier otro medio
            de los detallados anteriormente.
          </p>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i> CONDICIONES DE ACCESO Y
            UTILIZACIÓN
          </template>
          <p>
            El sitio web y sus servicios son de acceso libre y gratuito, no
            obstante, EL PROPIETARIO DE LA WEB condiciona la utilización de
            algunos de los servicios of recidos en su web a la previa
            cumplimentación del correspondiente formulario. El usuario garantiza
            la autenticidad y actualidad de todos aquellos datos que comunique a
            EL PROPIETARIO DE LA WEB y será el único responsable de las
            manifestaciones falsas o inexactas que realice. El usuario se
            compromete expresamente a hacer un uso adecuado de los contenidos y
            servicios de EL PROPIETARIO DE LA WEB y a no emplearlos para, entre
            otros:
          </p>
          <ul class="num">
            <li>
              Difundir contenidos, delictivos, violentos, pornográficos,
              racistas, xenófobos, ofensivos, de apología del terrorismo o, en
              general, contrarios a la ley o al orden público.
            </li>
            <li>
              Introducir en la red virus informáticos o realizar actuaciones
              susceptibles de alterar, estropear, interrumpir o generar errores
              o daños en los documen tos electrónicos, datos o sistemas físicos
              y lógicos de EL PROPIETARIO DE LA WEB o de terceras personas; así
              como obstaculizar el acceso de otros usu arios al sitio web y a
              sus servicios mediante el consumo masivo de los recursos
              informáticos a través de los cuales EL PROPIETARIO DE LA WEB
              presta sus servicios.
            </li>
            <li>
              Intentar acceder a las cuentas de correo electrónico de otros
              usuarios o a áreas restringidas de los sistemas informáticos de EL
              PROPIETARIO DE LA WEB o de terceros y, en su caso, extraer
              información.
            </li>
            <li>
              Vulnerar los derechos de propiedad intelectual o industrial, así
              como violar la confidencialidad de la información de EL
              PROPIETARIO DE LA WEB o de terceros.
            </li>
            <li>
              Suplantar la identidad de otro usuario, de las administraciones
              públicas o de un tercero.
            </li>
            <li>
              Reproducir, copiar, distribuir, poner a disposición o de cualquier
              otra forma comunicar públicamente, transformar o modificar los
              contenidos, a menos que se cuente con la autorización del titular
              de los correspondientes derechos o ello resulte legalmente
              permitido.
            </li>
            <li>
              Recabar datos con finalidad publicitaria y de remitir publicidad
              de cualquier clase y comunicaciones con fines de venta u otras de
              naturaleza comercial sin que medie su previa solicitud o
              consentimiento
            </li>
          </ul>
          <p>
            Todos los contenidos del sitio web, como textos, fotografías,
            gráficos, imágenes, iconos, tecnología, software, así como su diseño
            gráfico y códigos fuente, constituyen una obra cuya propiedad
            pertenece a EL PROPIETARIO DE LA WEB, sin que puedan entenderse
            cedidos al usuario ninguno de los derechos de explotación sobre los
            mismos más allá de lo estrictamente necesario para el correcto uso
            de la web.
          </p>
          <p>
            En definitiva, los usuarios que accedan a este sitio web pueden
            visualizar los contenidos y efectuar, en su caso, copias privadas
            autorizadas siempre que los elementos reproducidos no sean cedidos
            posteriormente a terceros, ni se instalen a servidores conectados a
            redes, ni sean objeto de ningún tipo de ex plotación. Asimismo,
            todas las marcas, nombres comerciales o signos distintivos de
            cualquier clase que aparecen en el sitio web son propiedad de EL
            PRO-PIETARIO DE LA WEB, sin que pueda entenderse que el uso o acceso
            al mismo atribuya al usuario derecho alguno sobre los mismos.
          </p>
          <p>
            La distribución, modificación, cesión o comunicación pública de los
            contenidos y cualquier otro acto que no haya sido expresamente
            autorizado por el titu lar de los derechos de explotación quedan
            prohibidas.
          </p>
          <p>
            El establecimiento de un hiperenlace no implica en ningún caso la
            existencia de relaciones entre EL PROPIETARIO DE LA WEB y el
            propietario del sitio web en la que se establezca, ni la aceptación
            y aprobación por parte de EL PROPIETARIO DE LA WEB de sus contenidos
            o servicios. Aquellas personas que se propongan establecer un
            hiperenlace previamente deberán solicitar autorización por escrito a
            EL PROPIETARIO DE LA WEB. En todo caso, el hiperenlace únicamente
            permitirá el acceso a la home page o página de inicio de nuestro
            sitio web, asimismo deberá abstenerse de realizar manifestaciones o
            indica ciones falsas, inexactas o incorrectas sobre EL PROPIETARIO
            DE LA WEB, o incluir contenidos ilícitos, contrarios a las buenas
            costumbres y al orden públi co. EL PROPIETARIO DE LA WEB no se
            responsabiliza del uso que cada usuario le dé a los materiales
            puestos a disposición en este sitio web ni de las actu aciones que
            realice en base a los mismos.
          </p>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>EXCLUSIÓN DE GARANTÍAS Y DE
            RESPONSABILIDAD
          </template>
          <p>
            El contenido del presente sitio web es de carácter general y tiene
            una finalidad meramente informativa, sin que se garantice plenamente
            el acceso a todos los contenidos, ni su exhaustividad, corrección,
            vigencia o actualidad, ni su idoneidad o utilidad para un objetivo
            específico. EL PROPIETARIO DE LA WEB excluye, hasta donde permite el
            ordenamiento jurídico, cualquier responsabilidad por los daños y
            perjuicios de toda naturaleza derivados de:
          </p>
          <ul>
            <li>
              La imposibilidad de acceso al sitio web o la falta de veracidad,
              exactitud, exhaustividad y/o actualidad de los contenidos, así
              como la existencia de vicios y defectos de toda clase de los
              contenidos transmitidos, difundidos, almacenados, puestos a
              disposición a los que se haya accedido a través del sitio web o de
              los servicios que se ofrecen.
            </li>
            <li>
              La presencia de virus o de otros elementos en los contenidos que
              puedan producir alteraciones en los sistemas informáticos,
              documentos electrónicos o datos de los usuarios.
            </li>
            <li>
              El incumplimiento de las leyes, la buena fe, el orden público, los
              usos del tráfico y el presente aviso legal como consecuencia del
              uso incorrecto del sitio web. En particular, y a modo
              ejemplificativo, EL PROPIETARIO DE LA WEB no se hace responsable
              de las actuaciones de terceros que vulneren derechos de propiedad
              intelectual e industrial, secretos empresariales, derechos al
              honor, a la intimidad personal y familiar y a la propia imagen,
              así como la nor mativa en materia de competencia desleal y
              publicidad ilícita.
            </li>
          </ul>
          <p>
            Asimismo, EL PROPIETARIO DE LA WEB declina cualquier responsabilidad
            respecto a la información que se halle fuera de esta web y no sea
            gestionada di rectamente por nuestro webmaster. La función de los
            links que aparecen en esta web es exclusivamente la de informar al
            usuario sobre la existencia de otras fuentes susceptibles de ampliar
            los contenidos que ofrece este sitio web. EL PROPIETARIO DE LA WEB
            no garantiza ni se responsabiliza del funciona miento o
            accesibilidad de los sitios enlazados; ni sugiere, invita o
            recomienda la visita a los mismos, por lo que tampoco será
            responsable del resultado ob tenido. EL PROPIETARIO DE LA WEB no se
            responsabiliza del establecimiento de hipervínculos por parte de
            terceros.
          </p>
        </el-collapse-item>
        <el-collapse-item name="5">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>POLÍTICA DE PRIVACIDAD
          </template>
          <p>
            Puede revisar nuestra política de privacidad en el siguiente
            <el-link type="peimary" @click="$router.puash('/enlace')"
              >enlace</el-link
            >.
          </p>
        </el-collapse-item>
        <el-collapse-item name="6">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>PROCEDIMIENTO EN CASO DE
            REALIZACIÓN DE ACTIVIDADES DE CARACTER ILÍCITO
          </template>
          <p>
            En el caso de que cualquier usuario o un tercero considere que
            existen hechos o circunstancias que revelen el carácter ilícito de
            la utilización de cualquier contenido y/o de la realización de
            cualquier actividad en las páginas web incluidas o accesibles a
            través del sitio web, deberá enviar una notificación a EL
            PROPIETARIO DE LA WEB identificándose debidamente, especificando las
            supuestas infracciones y declarando expresamente y bajo su
            responsabilidad que la información proporcionada en la notificación
            es exacta.
          </p>
          <p>
            Las partes se someten expresamente, para cualesquiera cuestiones o
            divergencias que pudieren suscitarse por razón de la interpretación,
            cumplimiento y ejecución de este contrato, a la jurisdicción y
            competencia de los Juzgados y Tribunales correspondientes al
            domicilio del usuario o a los del lugar de cum plimiento de la
            obligación contractual.
          </p>
        </el-collapse-item>
        <el-collapse-item name="7">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>PUBLICACIONES
          </template>
          <p>
            La información administrativa facilitada a través del sitio web no
            sustituye la publicidad legal de las leyes, normativas, planes,
            disposiciones generales y actos que tengan que ser publicados
            formalmente a los diarios oficiales de las administraciones
            públicas, que constituyen el único instrumento que da fe de su
            autenticidad y contenido. La información disponible en este sitio
            web debe entenderse como una guía sin propósito de validez legal.
          </p>
        </el-collapse-item>
      </el-collapse>
    </div>
  </pageContent>
</template>

<script>
import pageContent from "@/components/pageContent.vue"
export default {
  name: "aviso",
  components: {
    pageContent,
  },
  data() {
    return {
      activeNames: 0,
    }
  },
  methods: {},
}
</script>
<style lang="scss">
.aviso-main {
  padding-left: 50px;
  padding-right: 50px;
  position: relative;
  top: -220px;
  .row-text {
    text-align: center;
    color: #fff;
    margin-bottom: 180px;
    .font-blod {
      font-size: calc(var(--font-size) * 3);
      &.black {
        color: #000000;
      }
    }
  }
}
// .collapse {
//   .header-icon {
//     font-size: 50px;
//   }
// }
</style>
